import SkuWithZeroFacings from "./SkuWithZeroFacings";
export default SkuWithZeroFacings;
